module.exports = __webpack_public_path__ + "41f8c0b3de16d7cd2f2eee418887de8d.pdf";